// extracted by mini-css-extract-plugin
export default {"SinglePage_main_div":"SinglePage_SinglePage_main_div__yvmNb"};